import { Search } from '../../types';

const FOURTEEN_DAYS = 14 * 24 * 60 * 60 * 1000;

const creationTime = (value: string) => {
  // The API can return zone-less UTC. Read it as UTC even across a local
  // daylight-saving change, which would otherwise shift the 14-day boundary.
  const text = value.trim().replace(' ', 'T');
  return Date.parse(/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(:\d{2})?(\.\d+)?$/.test(text) ? `${text}Z` : text);
};

/** null means the refetched list does not contain the entire creation batch yet. */
export function shouldShowSearchStartedNotice(searches: Search[], createdIds: string[]): boolean | null {
  if (createdIds.length === 0) return false;
  const ids = new Set(createdIds);
  const batch = searches.filter((search) => ids.has(search.id));
  if (batch.length !== ids.size) return null;
  const previous = searches.filter((search) => !ids.has(search.id));
  if (previous.length === 0) return true;
  // Compare server timestamps, so the user's clock and time spent on the
  // drawer's success panel cannot move a creation across the 14-day boundary.
  const createdAt = Math.min(...batch.map((search) => creationTime(search.createdAt)));
  const lastCreatedAt = Math.max(...previous.map((search) => creationTime(search.createdAt)));
  return createdAt - lastCreatedAt >= FOURTEEN_DAYS;
}
